import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { DEFAULT_CONTENT_WIDTH } from '@/features/marketplace/constants';
import { FeaturesHorizontalCarousel } from './components/features-list';
import { tabData } from './tab-data';
import { TabTranslation } from './types';

const WhyJoinUsSection = () => {
  const { t } = useTranslation();

  const featuresTranslations = t('js.features.marketplace.home.third_section.tabs', {
    returnObjects: true,
  }) as TabTranslation[];

  return (
    <section className="w-full overflow-hidden bg-bg-primaryMedium">
      <div className={clsx(DEFAULT_CONTENT_WIDTH, 'm-auto flex-1')}>
        <div className="mt-8 flex w-full items-center justify-between">
          <h2 className={clsx(
            'text-h3 font-bold text-text-primary',
            'leading-[3.7rem]',
            'sm:text-[4.8rem] sm:leading-[5.5rem]'
          )}>
            {t('js.features.marketplace.home.third_section.title')}
          </h2>
        </div>
      </div>
      <FeaturesHorizontalCarousel
        featuresData={tabData}
        featuresTranslations={featuresTranslations}
      />
    </section>
  );
};

export { WhyJoinUsSection };
